import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate , useLocation } from "react-router-dom";

import AppRouter from "./routes/AppRoutes";
import { silentRefresh } from "./services/authservice";
import store from "./store";

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          fontFamily: "Nunito, sans-serif",
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            cursor: "not-allowed !important",
            pointerEvents: "auto",
          },
        },
      },
    },
  },
});

const AppWrapper = () => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>
);

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const publicPaths = [
      "/",
      "/login",
      "/registration",
      "/forgotPassword",
      "/reset-password",
    ];

    if (publicPaths.includes(location.pathname)) {
      setIsAuthChecked(true);
      return;
    }

    setIsAuthChecked(false);
    (async () => {
      const success = await silentRefresh();
      setIsAuthChecked(true);

      if (!success) {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.pathname, navigate]);

  if (!isAuthChecked) {
    return (
      <div style={{ color: "white", textAlign: "center", padding: "20px" }}>
        Checking session...
      </div>
    );
  }

  return <AppRouter />;
}

export default AppWrapper;
